import InfoPopup from "@/components/InfoPopup/InfoPopup";
import { LabelLocation, Toggle } from "@/components/Toggle";
import { useTrans } from "@/translations";

import React from "react";

type ShowAllWasteStreamsToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  defaultLimit: number;
};

const ShowAllWasteStreamsToggle: React.FC<ShowAllWasteStreamsToggleProps> = ({
  checked,
  onChange,
  defaultLimit,
}) => {
  const { t } = useTrans();

  return (
    <>
      <div className="-mr-2 flex flex-col items-end">
        <Toggle
          label={
            <>
              <label className="text-sm">
                {t("circularityLabels:showAllWasteStreams")}
                <InfoPopup
                  className="-mb-1 ml-2 inline-block"
                  id="toggleFootprintData"
                  text={t("circularityLabels:showAllWasteStreamsHint", {
                    limit: defaultLimit * 100,
                  })}
                  width="300px"
                  size={15}
                />
              </label>
            </>
          }
          labelLocation={LabelLocation.LEFT}
          checked={checked}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default ShowAllWasteStreamsToggle;
